document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('submit', async function (e) {
    const form = e.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();

    try {
      const formData = new FormData(form);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      window.location.href = '/checkout';
    } catch (error) {
      console.error('Direct checkout error:', error);
    }
  });

  document.addEventListener('click', async function (e) {
    const button = e.target.closest(
      'button[name="add"], .product-form__submit, .quick-add__submit, .add-to-cart, [data-add-to-cart]'
    );

    if (!button) return;

    const form = button.closest('form');

    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    if (button.type === 'submit') return;

    e.preventDefault();

    try {
      const formData = new FormData(form);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      window.location.href = '/checkout';
    } catch (error) {
      console.error('Direct checkout click error:', error);
    }
  });
});